<script setup>
import BoundedComponent from '@/components/BoundedComponent.vue';

const doThat = [
  {
    icon: 'point',
    content: {
      q: 'Kunnum við að rata?',
      a: 'Prófaðu að komast á milli staða án aðstoðar frá símanum. Ef þú villist þá geturðu alltaf látið Maps bjarga þér.',
    },
    alt: 'punktur',
  },
  {
    icon: 'cutlery',
    content: {
      q: 'Kunnum við að velja?',
      a: 'Prófaðu að láta innsæið ráða för við val á veitingastað í útlöndum fremur en að eyða tíma í að velja þann sem fær bestu einkunn á netinu.',
    },
    alt: 'hnífapör',
  },
  {
    icon: 'sound-off',
    content: {
      q: 'Kunnum við að vera ein í þögn?',
      a: 'Hvenær fórstu á salernið síðast án þess að vera í símanum? Hægðu á þér og hægðu þér - í friði.',
    },
    alt: 'hljóð slökkt',
  },
  {
    icon: 'schedule',
    content: {
      q: 'Kunnum við að muna?',
      a: 'Hvenær lagðir þú eitthvað á minnið síðast? Kanntu símanúmerin hjá fjölskyldu og bestu vinum? Það gæti komið sér vel að muna þau.',
    },
    alt: 'áætlun',
  },
  {
    icon: 'clouds',
    content: {
      q: 'Kunnum við að tala saman?',
      a: 'Við missum stundum af skemmtilegum samræðum eða sögum í góðra vina hópi og dettum í símann. Prófaðu að vera 100% til staðar.',
    },
    alt: 'skýjum',
  },
  {
    icon: 'clock',
    content: {
      q: 'Kunnum við að vera í núinu?',
      a: 'Förum í keppni! Fyrstur til að fara í símann þegar við erum úti að borða þarf að borga!',
    },
    alt: 'klukka',
  },
];
</script>

<template>
  <BoundedComponent
    is="section"
    className="mt-71"
    childClassName="bg-yellow rounded-[40px] pt-10 inner-block-px lg:pt-12.5 lg:pt-15 pb-25 lg:pb-40 text-center"
  >
    <h2 v-bounce-in class="text-[40px] lg:text-6xl text-brown mb-6">
      Hvernig fórum við að?
    </h2>
    <p
      v-bounce-in
      class="text-brown mb-10 xs:mb-14 lg:mb-17.5 max-w-[660px] lg:text-lg mx-auto"
    >
      Það getur verið hollt að velta fyrir sér hvað við gerðum áður en
      snjalltækin komu til sögunnar og hvernig okkur gengi að komast af án
      þeirra í dag.
    </p>
    <div
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-16 xl:gap-y-20 gap-x-4 xl:gap-x-7.5"
    >
      <div v-for="item in doThat" :key="item.icon" v-bounce-in>
        <img
          :src="`/images/do-that/${item.icon}.svg`"
          :alt="item.icon"
          class="h-14 w-auto mx-auto mb-4"
          loading="lazy"
          width="68"
          height="56"
        />
        <div class="mb-2 text-lg font-bold">{{ item.content.q }}</div>
        <p class="max-w-md text-center mx-auto">{{ item.content.a }}</p>
      </div>
    </div>
  </BoundedComponent>
</template>
